
const BarDataAPI = (response) => {

    var datos = []
    var categories = []

    response.data.map(item => {
        datos.push(
            {
                y: item.valor,
                color: item.color
            }
        )
        categories.push(item.label)

    });
    return { datos: datos, categories: categories }
}

export default BarDataAPI




